import "./App.css";
import "@radix-ui/themes/styles.css";
import { Theme } from "@radix-ui/themes";
import ThemeRoutes from "./routes";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsexports from "./aws-exports";

Amplify.configure(awsexports);

function App() {
  return (
    <Theme accentColor="jade">
      <BrowserRouter>
        <ThemeRoutes />
      </BrowserRouter>
    </Theme>
  );
}

export default App;
